import DefaultMainPage from "../../../pages/DefaultMainPage";
import MergeEventTable from "./MergeEventTable";
import MergeEventManager from "./MergeEventManager";

const mergeEventMasterMenuItems = [
    {path: "/mergeEventMaster", component: <MergeEventManager/>, label: '머지 이벤트'},
    {path: "/mergeEventMaster/table", component: <MergeEventTable/>, label: '머지 이벤트 마스터'},
];

export const mergeEventMasterRoutes = {
    path: "/mergeEventMaster",
    component: <DefaultMainPage buttons={mergeEventMasterMenuItems}/>,
    children: mergeEventMasterMenuItems
}